import { NOT_FOUND_ROUTE } from 'config/route-consts';
import { GlobalState } from 'core/config';
import React, { useContext } from 'react';
import { Switch, useHistory, withRouter } from 'react-router';
import {
  renderRoutes,
  RouteConfig,
  RouteConfigComponentProps,
} from 'react-router-config';
import { setGlobal } from 'reactn';
import { MenuContext } from 'core/components/App/AppContext';
import DefaultHeader from './DefaultHeader/DefaultHeader';
import './DefaultLayout.scss';
import DefaultSidebar from './DefaultSidebar/DefaultSidebar';

function DefaultLayout(props: RouteConfigComponentProps) {
  const history = useHistory();
  const { route, location } = props;
  const [toggle, setToggle] = React.useState<boolean>(true);
  React.useEffect(() => {
    const params = window.location.pathname.split('/');
    const param = window.location.pathname.split('/')[params.length];
    setGlobal<GlobalState>({ toggleSideBar: toggle });
    if (param) {
      if (param !== 'create' || !+param.match(/^[0-9]+$/)) {
        history.push(NOT_FOUND_ROUTE);
      }
    }
  }, [history, location, toggle]);
  const handleClickToggle = React.useCallback(() => {
    setToggle(!toggle);
    setGlobal<GlobalState>({ toggleSideBar: !toggle });
  }, [toggle]);

  const routes = useContext<RouteConfig[]>(MenuContext);

  const existMenu = React.useMemo(() => {
    let existMenu = false;
    if (routes?.length > 0) {
      routes.forEach((menu) => {
        if (menu?.isShow === true) {
          existMenu = true;
        }
      });
    }
    return existMenu;
  }, [routes]);
  const sideBar = React.useMemo(
    () => (
      <DefaultSidebar
        className={toggle === true && existMenu ? 'slide-in' : 'slide-out'}
      />
    ),
    [existMenu, toggle],
  );
  // sua layout tai day
  return (
    <div className="app">
      <div
        className={
          toggle === true && existMenu ? 'header-wrapper' : 'header-wrapper-out'
        }
      >
        <DefaultHeader
          className={toggle === true && existMenu ? 'header-in' : 'header-out'}
          onToggle={handleClickToggle}
        />
      </div>

      <div className="app-body">
        {sideBar}
        <main
          className={
            toggle === true && existMenu
              ? 'main content-in'
              : 'main content-out'
          }
        >
          <div className="app-content">
            <Switch>
              {route?.routes instanceof Array && renderRoutes(route.routes)}
            </Switch>
          </div>
        </main>
      </div>
    </div>
  );
}

export default withRouter(DefaultLayout);
